import classNames from 'classnames';
import React from 'react';
import ReactPaginate from 'react-paginate';
import style from './index.module.scss';

interface IPagination {
  className?: string;
  count: number;
  pageIndex: number;
  handlePageClick: (value: number) => void;
}

interface IEvent {
  selected: number;
}

function Paginator(props: IPagination) {
  const {className, count, pageIndex, handlePageClick} = props;
  const pageChange = (event: IEvent) => {
    handlePageClick(event.selected);
  };

  return count > 1 ? (
    <div className={classNames(style['paginator'], className)}>
      <ReactPaginate
        breakLabel='...'
        nextLabel='next >'
        previousLabel='< previous'
        onPageChange={pageChange}
        pageCount={count}
        pageRangeDisplayed={1}
        marginPagesDisplayed={5}
        forcePage={pageIndex}
      />
    </div>
  ) : null;
}

export default Paginator;
